<div class="latest-event-overlay">
  <!-- Animation Video -->
  <video 
    *ngIf="isPlayingAnimation && currentAnimationPath"
    class="animation-video"
    [src]="currentAnimationPath"
    autoplay
    muted
    loop="false"
    playsinline
  ></video>
  
  <!-- Username Display -->
  <div 
    *ngIf="!isPlayingAnimation" 
    class="latest-event-content"
  >
    <div class="platform-icon">
      <svg
        *ngIf="latestEvent?.source === 'Twitch'"
        width="20"
        height="20"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.9287 5.87101H33.1898V21.6565L28.2503 26.673H20.5016L16.2739 30.974V26.673H9.9287V5.87101ZM7.10765 3L5 8.74201V31.689H12.7487V36H16.9749L21.201 31.689H27.5477L36 23.087V3H7.10765Z"
          fill="#ffffff"
        />
        <path
          d="M24.3314 19H27V10H24.3314V19ZM17.0015 18.9885H19.6701V10H17L17.0015 18.9885Z"
          fill="#ffffff"
        />
      </svg>
      <svg
        *ngIf="latestEvent?.source === 'YouTube'"
        width="20"
        height="20"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1232_6534)">
          <mask
            id="mask0_1232_6534"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="5"
            width="41"
            height="31"
          >
            <path
              d="M39.8232 5.66699H-0.176758V35.0003H39.8232V5.66699Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1232_6534)">
            <path
              d="M39.8185 19.8934C39.803 16.8956 39.7999 13.7383 39.0055 10.8272C38.4401 8.75691 36.7644 6.81637 34.6387 6.49256C29.7421 5.73992 24.8001 5.66699 19.8516 5.66699C14.8857 5.66699 9.92245 5.73258 5.00849 6.4843C2.87835 6.8104 1.19199 8.75966 0.635495 10.8305C-0.172627 13.8309 -0.169964 17.0938 -0.175733 20.1892C-0.180615 23.3658 -0.199697 26.7359 0.64437 29.8208C1.20974 31.8847 2.88279 33.811 4.99917 34.1459C9.47291 34.8517 13.9706 34.965 18.4949 34.9925C23.8931 35.0256 29.3089 34.9838 34.6485 34.1394C36.7631 33.8051 38.4339 31.8788 38.9975 29.8162C39.8651 26.6401 39.8358 23.1658 39.8185 19.8929M21.0502 23.4905L15.7772 26.6369V14.052L21.0502 17.1983L26.3227 20.3437L21.0502 23.4905Z"
              fill="#ffffff"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1232_6534">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <span class="username">
      {{ isLoading ? "LOADING..." : (latestEvent?.username | uppercase) }}
    </span>
  </div>
</div>
